import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { FiltroColaborador } from '../models/filtro-colaborador';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';

@Injectable({
  providedIn: 'root'
})
export class FiltroColaboradorService {

  private filterSubject: BehaviorSubject<FiltroColaborador>;
  public filter: Observable<FiltroColaborador>;

  constructor() {
    this.filterSubject = new BehaviorSubject<FiltroColaborador>(JSON.parse(localStorage.getItem(LocalStoreKeys.filtroColaborador)));
    this.filter = this.filterSubject.asObservable();
  }

  public getFilterValue(): FiltroColaborador {
    return this.filterSubject.value;
  }

  public setFilterValue(filter: FiltroColaborador) {
    localStorage.setItem(LocalStoreKeys.filtroColaborador, JSON.stringify(filter));
    this.filterSubject.next(filter);
  }

  public clear() {
    this.filterSubject.next(null);
  }
}
